import React, { useEffect, useState } from 'react';

import HttpClient from '@/http/HttpClient';
import { setApplicationCategory, setCategoryImages, setKnowledgeCategory, setSiteImageConfig } from '@/model/core';
import { storeDispatch } from '@/model/store';

const LazyImportComponent = ({ lazyChildren: LazyComponent }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoaded(false);
      const cachedSiteImageConfig = window.sessionStorage.getItem('siteImageConfig');
      if (cachedSiteImageConfig) {
        const siteImageConfig = JSON.parse(cachedSiteImageConfig);
        storeDispatch(setSiteImageConfig(siteImageConfig));
      } else {
        const res = await HttpClient.get('/api/site-image-configs');
        window.sessionStorage.setItem('siteImageConfig', JSON.stringify(res));
        storeDispatch(setSiteImageConfig(res));
      }
      setIsLoaded(true);

      const cachedCategories = window.sessionStorage.getItem('categories');
      const categoryImages = {};
      if (cachedCategories) {
        const categories = JSON.parse(cachedCategories);
        categories.forEach(category => {
          if (category.type === 'KNOWLEDGE') {
            storeDispatch(setKnowledgeCategory(category.children));
          } else if (category.type === 'APPLICATION') {
            storeDispatch(setApplicationCategory(category.children));
          }
          if (category.imageUri) {
            categoryImages[category.id] = category.imageUri;
            category.children.forEach(child => {
              if (child.imageUri) {
                categoryImages[child.id] = child.imageUri;
              }
            });
          }
        });
      } else {
        const categoryRes = await HttpClient.get('/api/categories/tree');
        window.sessionStorage.setItem('categories', JSON.stringify(categoryRes));
        categoryRes.forEach(category => {
          if (category.type === 'KNOWLEDGE') {
            storeDispatch(setKnowledgeCategory(category.children));
          } else if (category.type === 'APPLICATION') {
            storeDispatch(setApplicationCategory(category.children));
          }
          if (category.imageUri) {
            categoryImages[category.id] = category.imageUri;
            category.children.forEach(child => {
              if (child.imageUri) {
                categoryImages[child.id] = child.imageUri;
              }
            });
          }
        });
      }

      storeDispatch(setCategoryImages(categoryImages));
    })();
  }, []);
  return isLoaded ? <React.Suspense fallback={<></>}>{LazyComponent}</React.Suspense> : <></>;
};

export default LazyImportComponent;
